import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';
import { ESTATUS_AUTORIZADO } from 'utils/constants';

export const baseURI = 'nominas/bimestre';

/**
 * GET Bimestres
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getBimestres = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Bimestre
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getBimestre = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Bimestre
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postBimestre = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Bimestre
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchBimestre = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Bimestre
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteBimestre = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * AUTORIZAR Bimestre
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const autorizarBimestre = async (id) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, {
      estados_globales: ESTATUS_AUTORIZADO,
    });
    onSuccess(response, 'Autorizado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * Genera, de forma masiva, los 6 Bimestres estándar (Bimestre 1..6) de un
 * Periodo Fiscal. Omite, sin error, los que ya existan para ese periodo.
 * @param {number} periodoFiscalId
 * @returns {Promise<object|boolean>}
 */
export const generarBimestres = async (periodoFiscalId) => {
  try {
    const response = await API.post(`${baseURI}/generar-bimestres`, {
      periodo_fiscal: periodoFiscalId,
    });
    onSuccess(response, 'Bimestres generados correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};
